import React from "react";
import { SectionHeader } from "./SectionHeader";

export const Comparison = ({ data }) => {
  if (!data) return null;
  return (
    <div id="comparison">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            <SectionHeader heading={data.heading} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-10 col-md-offset-1">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th className="comp-col-traditional">{data.col_traditional}</th>
                  <th className="comp-col-coco">{data.col_coco}</th>
                </tr>
              </thead>
              <tbody>
                {data.rows.map((row, i) => (
                  <tr key={i}>
                    <td className="comp-traditional">
                      <i className="fa fa-times comp-x"></i> {row.traditional}
                    </td>
                    <td className="comp-coco">
                      <i className="fa fa-check comp-check"></i> {row.coco}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
